export default __webpack_public_path__ + "static/media/Road Safety Training flyer.9ae0b8b2.pdf";